export const HomeF1Image = require('./f-1.jpg.png');
export const HomeF2Image = require('./f-2.jpg.png');
export const HomeF3Image = require('./f-3.jpg.png');
export const HomeF4Image = require('./f-4.jpg.png');
export const HomeF5Image = require('./f-5.jpg.png');